<template>
  <b-modal id="modal-aju" title="Aju Baru" variant="success" ref="modalAju" hide-footer no-close-on-esc
    no-close-on-backdrop>
    <loading :active.sync="this.$store.state.barpin.isLoadingModal" :is-full-page="false"></loading>
    <!-- Fields -->
    <form @submit.prevent="addAju">
      <b-form-fieldset label="Jenis Aju">
        <b-form-select name="Jenis Aju" :class="errors.has('Jenis Aju') ? 'is-invalid' : ''" :options="[
          {
            text: 'Jenis Pengajuan',
            value: ''
          },
          {
            text: 'Barang Pindahan',
            value: 1
          },
          {
            text: 'Kendaraan Bermotor',
            value: 2
          }
        ]" v-model="jenis_aju" v-validate="'required'"></b-form-select>
        <div v-show="errors.has('Jenis Aju')" class="invalid-feedback">{{ errors.first('Jenis Aju') }}</div>
      </b-form-fieldset>
      <b-form-fieldset label="Nama Pemohon">
        <b-form-input name="Nama Pemohon" v-model="nama_penerima" type="text" v-validate="'required'" :class="errors.has('Nama Pemohon') ? 'is-invalid' : ''"></b-form-input>
        <div v-show="errors.has('Nama Pemohon')" class="invalid-feedback">{{ errors.first('Nama Pemohon') }}</div>
      </b-form-fieldset>
      <b-form-fieldset label="Jenis Identitas">
        <model-list-select class="form-control" :list="ref_identitas" option-value="kd_id" option-text="URAIAN"
          v-model="jenis_identitas_penerima" name="Jenis Identitas" v-validate="'required'"
          placeholder="Jenis Identitas" :class="errors.has('Jenis Identitas') ? 'is-invalid' : ''"></model-list-select>
        <div v-show="errors.has('Jenis Identitas')" class="invalid-feedback">{{ errors.first('Jenis Identitas') }}</div>
      </b-form-fieldset>
      <b-form-fieldset label="Nomor Identitas">
        <b-form-input name="Nomor Identitas" v-model="no_identitas_penerima" type="text" v-validate=" jenis_identitas_penerima === '5' ? 'required|min:16' : 'required' " :class="errors.has('Nomor Identitas') ? 'is-invalid' : ''">
        </b-form-input>
        <div v-show="errors.has('Nomor Identitas')" class="invalid-feedback">{{ errors.first('Nomor Identitas') }}</div>
      </b-form-fieldset>
      <slot id="footer">
        <hr />
        <button type="submit" class="btn btn-success pull-right">
          <i class="fa fa-plus"></i> Buat Aju
        </button>
      </slot>
    </form>
  </b-modal>
</template>
<script>
import swal from 'sweetalert'
import {mapGetters} from 'vuex'
import {ModelListSelect} from 'vue-search-select'
export default {
  components: {ModelListSelect},
  data () {
    return {
      jenis_aju: '',
      nama_penerima: this.$store.state.auth.user.NM_PERUSAHAAN,
      jenis_identitas_penerima: this.$store.state.auth.user.kdid,
      no_identitas_penerima: this.$store.state.auth.user.npwp,
      ref_identitas: [{kd_id: '2', URAIAN: 'KTP'}, {kd_id: '3', URAIAN: 'Paspor'}, {kd_id: '4', URAIAN: 'Lainnya'}, {kd_id: '5', URAIAN: 'NPWP 16 Digit'}]
    }
  },
  methods: {
    addAju () {
      this.$validator.validateAll().then((result) => {
        if (result) {
          var data = {
            jns_aju: this.jenis_aju,
            nama_penerima: this.nama_penerima,
            jenis_identitas_penerima: this.jenis_identitas_penerima,
            no_identitas_penerima: this.no_identitas_penerima
          }
          this.$store.commit('barpin/SET_LOADING_MODAL', true)
          this.$http.post('ppftz', data).then((response) => {
            this.$store.commit('barpin/SET_LOADING_MODAL', false)
            this.$refs['modalAju'].hide()
            swal('success', 'Berhasil membuat aju baru', 'success').then(() => {
              this.$router.push(`perekaman/${response.data}`)
            })
          }).catch((error) => {
            swal('error', JSON.parse(error.bodyText).message, 'error')
            this.$store.commit('barpin/SET_LOADING_MODAL', false)
          })
        }
      })
    }
  },
  computed: {
    ...mapGetters({
      authenticated: 'auth/authenticated',
      user: 'auth/user'
    })
  }
}
</script>


// WEBPACK FOOTER //
// src/views/ppftz/modal/ModalAju.vue?4123cd40